/** Files of one request are sent one after another, so the request's loaded bytes are split across them in order. */
export const getUploadProgressByEachFile = (event, files) => {
  const result = {}
  let loadedBefore = 0

  files.forEach(file => {
    const fileLoaded = Math.min(Math.max(event.loaded - loadedBefore, 0), file.size)
    result[file.id] = file.size ? (fileLoaded / file.size) * 100 : 100
    loadedBefore += file.size
  })

  return result
}
